import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { createRequest } from '../../utils/helpers/api_utils';
import { apiUrl } from '../../utils/api_service/api_url';
import { finishSignIn } from '../../utils/auth/finishSignIn';
import { clearPending, setPending } from '../../utils/auth/mfaHandoff';

/**
 * Landing page after the IdP round-trip. The backend redirects here with a
 * one-time code (never a token) which is exchanged for either a session or,
 * when the user still owes a second factor, the MFA challenge / enrolment
 * token — handed to the MFA pages the same way password login does.
 */
export const SsoCallback = () => {
  const history = useHistory();
  const [error, setError] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const deepLink = params.get('next') || '';
    if (!code) { setError(true); return; }
    fetch(createRequest(`${apiUrl}/auth/sso/exchange`, 'POST', 'application/json', false, { code }))
      .then((r) => r.json())
      .then(async (d) => {
        if (!d.success) { setError(true); return; }
        if (d.mfaRequired && d.challengeToken) {
          setPending('challenge', d.challengeToken, deepLink);
          history.replace('/auth/mfa');
          return;
        }
        if (d.mfaEnrollmentRequired && d.enrollToken) {
          setPending('enroll', d.enrollToken, deepLink);
          history.replace('/auth/mfa/enroll');
          return;
        }
        if (!d.accessToken) { setError(true); return; }
        clearPending('challenge');
        clearPending('enroll');
        // One seam for "signed in": SSO ends in the same state as password login.
        history.replace(await finishSignIn(d, { deepLink }));
      })
      .catch(() => setError(true));
    // eslint-disable-next-line
  }, []);

  return (
    <div className='min-h-screen flex items-center justify-center text-slate-500'>
      {error ? (
        <div className='text-center'>
          <p className='mb-3'>We could not complete sign-in.</p>
          <button className='underline text-emerald-600' onClick={() => history.push('/login')}>Back to sign in</button>
        </div>
      ) : (
        <p>Signing you in…</p>
      )}
    </div>
  );
};
